import { throttle } from 'throttle-debounce'

const detectNavOverflow = () => {
	// Fetch the elements needed for our width calculations
	let navEls = document.querySelectorAll('.js-nav-overflow')

	/**
	 * This function will add up the widths of all the individual menu items and calculate if there is room for them in the nav.
	 * Any items that do not fit are hidden and their counterpart in the "overflow menu" are made visible.
	 * We throttle this funtion so that it only runs every 200ms while the screen is resized.
	 */
	const checkNavItems = () => {

		let screenWidth = window.screen.width

		for (let i = 0; i < navEls.length; i++) {
			const navEl = navEls[i];
			const navItems = navEl.querySelectorAll('.js-overflow-item')
			const overflowDropdownItem = navEl.querySelector('.c-header__open-nav-overflow')
			let hasOverflow = false

			// Remove the overflow hidden once the page has loaded
			navEl.classList.remove('overflow-hidden')
			navEl.classList.add('overflow-visible')

			// Only run this on desktop view
			if (screenWidth > 820) {
				let navElWidth = navEl.offsetWidth - 58 // nav width width of expand icon + 10px padding
				let itemWidth = 0

				// Loop through all of our nav items and add up their widths, hide if wider than nav element
				for (let i = 0; i < navItems.length; i++) {
					const element = navItems[i]

					// Find this menus matching overflow link
					let menuItemId = element.dataset.overflowId
					let overflowItem = navEl.querySelector('.c-header__nav-overflow [data-overflow-id="' + menuItemId + '"]')

					if (!overflowItem) return

					itemWidth = itemWidth + element.offsetWidth

					if (itemWidth >= navElWidth) {
						hasOverflow = true

						// Hide the item and make it absolute so it doesn't affect the flow of elements
						element.classList.add('opacity-0')
						element.classList.add('invisible')
						element.classList.add('absolute')

						// Show it's matching overflow link
						overflowItem.classList.remove('hidden')
					} else {
						// Show the item
						element.classList.remove('opacity-0')
						element.classList.remove('invisible')
						element.classList.remove('absolute')

						// Hide it's matching overflow link
						overflowItem.classList.add('hidden')
					}

					// If there is overflow add some padding-right and shows the dots
					if (hasOverflow) {
						overflowDropdownItem.classList.remove('hidden')
					} else {
						overflowDropdownItem.classList.add('hidden')
					}
				}
			} else {
				// Show all items
				for (let i = 0; i < navItems.length; i++) {
					const element = navItems[i]

					// Show the item
					element.classList.remove('opacity-0')
					element.classList.remove('invisible')
					element.classList.remove('absolute')
				}

				overflowDropdownItem.classList.remove('hidden')
			}

			// Fade in the nav once done
			navEl.classList.remove('opacity-0')
			navEl.classList.add('opacity-100')
		}
	}

	// Run on load
	window.addEventListener('load', () => {
		checkNavItems()
	})

	// Run on resize
	window.addEventListener(
		'resize',
		() => {
			throttle(275, checkNavItems())
		},
		{ passive: true },
	)
}

export default detectNavOverflow
